import functions from "./functions.js";
import Slider from "./Slider";
import pagination from "./pagination.js";
import tplLoader from "./tpl-loader.js";


const favourites = {
    $list: null,
    list: null,
    pauseChange: false,
    $form: null,
    loading: false,
    params: {
        template: 'favourites',
        unitIds: [],
        dateFrom: null,
        dateTo: null,
        sortBy: null,
        _page: null,
        perPage: null,
        persons: null,
        dates: null,
        language: null,
    },
    defaults : {
        template: 'favourites',
        unitIds: [],
        dateFrom: null,
        dateTo: null,
        sortBy: 12,
        _page: 1,
        perPage: 20,
        persons: 2,
        dates: null,
        language: functions.getLang(),
    },
    init() {
        if (! $('.favourites-list').length) return;
        if (! $('.favourites-form').length) return;
        favourites.$list = $('.favourites-list');
        favourites.list = favourites.$list[0];
        favourites.$form = $('.favourites-form');
        let cFavs = functions.getCookie('user_favourites');

        favourites.defaults.unitIds = cFavs ? cFavs.split(',') : [];


        favourites.$form.on('submit', e => {
            e.preventDefault();
            favourites.onChange();
        });

        $(window).on('hashchange', () => {
            favourites.pauseChange = true;
            clearTimeout(favourites.changeTimeout);
            favourites.changeTimeout = setTimeout(() => {
                favourites.getParams();
                functions.setFormData(favourites.$form, favourites.params);
                favourites.calc();
                favourites.pauseChange = false;
            }, 100);
        });

        $(document).on('click', '.pagination a[data-page]', e => {
            e.preventDefault();
            favourites.paginate(+$(e.currentTarget).attr('data-page'));
        });

        
        favourites.getParams();
        
        functions.setFormData(favourites.$form[0], favourites.params);

        // if (favourites.defaults.unitIds.length == 0) return;

        favourites.calc();

    },
    paginate(page) {
        if ( page != favourites.params._page ) {
            favourites.params._page = page;
        }
        let paginateParams = $.extend({}, favourites.params);
        $.map(paginateParams, (val, key) => {
            if ( favourites.defaults[key] == val ) {
                delete paginateParams[key];
            }
        });
        functions.setUrlData(paginateParams, true);
    },
    calc() {
        let cFavs = functions.getCookie('user_favourites');
        favourites.params.unitIds = cFavs ? cFavs.split(',') : [];
        this.splitDates(favourites.params);
        favourites.setLoadingMode();
        $.get('/services/list_calc/', favourites.params).then(response => {
            response = JSON.parse(response);
            favourites.list.innerHTML = response.html + pagination({
                currentPage: favourites.params._page,
                total: response.total,
                perPage: favourites.params.perPage
            });
            favourites.unsetLoadingMode();
            favourites.domInit();
        });
    },
    domInit() {
        functions.markFavourites();
        functions.addToFavourites();

        $('.add-favourites').on('remove-from-list', function(e) {
            // $(e.currentTarget).closest('.card-wrapper').remove();
            // favourites.calc();
        })

        let listSlider = [];
        $('[id^=list-slider]').each((i, elem) => {
            listSlider[i] = new Slider(elem, {
                loop: true,
                arrows: true,
                slides: {
                    perView: 1,
                },
                breakpoints: {
                    '(max-width: 576px)': {
                        slides : {
                            perView: 1,
                        },
                    },
                },
                autoLoadSlides: 1
            });
        });

        
        $('.special-offer').on('click', function(e) {
            e.preventDefault();
            location.href = $(this).closest('a').attr('data-discount-href');
        });



        observer.observe();
    },
    getParams() {
        favourites.params = $.extend({}, favourites.defaults, functions.getUrlData(true));
        if (favourites.params.numberOfPets) list.params.optionals = 'pets';

        // $.map(favourites.params, (val, key) => {
        //     if ( favourites.defaults[key] == val ) {
        //         delete favourites.params[key];
        //     }
        // });
    },
    onChange(e) {
        clearTimeout(favourites.changeTimeout);
        if ( favourites.pauseChange ) {
            return;
        }
        // if changed field is date range and not have dateFrom & dateTo prevent url push
        if ( e && e.target.name == 'dates' ) {
            let val = e.target.value.split(' - ');
            if ( val.length != 2 && val[0] != '') {
                return;
            }  
        }
        favourites.changeTimeout = setTimeout(() => {
            functions.setUrlData(favourites.getFormData(), true);
        }, 300);
    },
    getFormData() {
        let formData = $.extend(
            functions.getFormData(favourites.$form), {
                _page: favourites.paginated ? favourites.params._page : 1,
                sortBy: favourites.paginated ? favourites.params.sortBy : 12
            }
        );        
        // Logic from old web
        if(formData.numberOfPets) formData.optionals = 'pets';
        
        favourites.paginated = false;
        // do not send same values as defaults
        $.map(formData, (val, key) => {
            if ( favourites.defaults[key] == val ) {
                delete formData[key];
            }
        });

        return formData;
    },
    splitDates(params) {
        if(params.dates)
        {
            let val = params.dates.split(' - ');
            params.dateFrom  = val[0];
            params.dateTo    = val[1];
            params.dates = null;
        }
        else
        {
            return;
        } 
    },
    setLoadingMode() {
        if ( !favourites.loading ) {
            favourites.loading = true;
            // favourites.$body.addClass('loading');
            favourites.$list.prepend(tplLoader).scrollTop(0);
            favourites.$list.scrollTop(0); // mobile
            favourites.$list.scrollTop(0);

        }
    },
    unsetLoadingMode() {
        if ( favourites.loading ) {
            favourites.loading = false;
            // favourites.$body.removeClass('loading').find('.list-loader').remove();
        }
    },
}

$(() => {
    favourites.init();    
});